var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShow
    ? _c(
        "div",
        {
          staticClass: "popup-ad d-none d-lg-block",
          class: {
            show: _vm.isVisible,
            "animate-in": _vm.animateIn,
            "animate-out": _vm.animateOut,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "popup-content",
              on: { click: _vm.handleContentClick },
            },
            [
              _c(
                "button",
                { staticClass: "popup-close", on: { click: _vm.hideAd } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/tcclose.png"),
                      alt: "关闭",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.adData && !_vm.isLoading && !_vm.hasError
                ? _c("div", { staticClass: "popup-ad-content" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.adData.url, target: "_blank" },
                        on: { click: _vm.handleAdClick },
                      },
                      [
                        _c("img", {
                          staticClass: "ad-image",
                          attrs: {
                            src: _vm.adData.cover,
                            alt: _vm.adData.title || "广告",
                          },
                          on: { load: _vm.handleImageLoad },
                        }),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoading
                ? _c("div", { staticClass: "popup-loading" }, [
                    _c("div", { staticClass: "loading-spinner" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("加载中...")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasError
                ? _c("div", { staticClass: "popup-error" }, [
                    _c("p", [_vm._v("加载失败")]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }